export default "__VITE_ASSET__137b1f39__"